import React from 'react';

// DEPENDENCIES
import clsx from 'clsx';

// GLOBAL COMPONENTS
import Form from 'core/form/Form';

// STYLES
import styles from './formRow.module.scss';

// MAIN COMPONENT
const FormRow = ({ className, children, ...props }) => {
  return (
    <Form.Row {...props} className={clsx('w-100', styles.row, className)}>
      {children}
    </Form.Row>
  );
};

// EXPORT
export default FormRow;
